var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 22V6h-20v8h-8v28h16v-8h4v8h16V22h-8zm-20 16h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm8 8h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm8 16h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm8 24h-4v-4h4v4zm0-8h-4v-4h4v4z",
    fill: "url(#z461v0azha)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "z461v0azha",
    x1: 6.5,
    y1: 6,
    x2: 44.692,
    y2: 8.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6033"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.732e84389615b5f71463dce0fd6e1178.svg";
export { ForwardRef as ReactComponent };